import React from 'react';
import { Box, Checkbox, Typography } from '@drone-js/core';
import { CategoryWithSubcategoryFilterItemProps } from 'component/page/search/SortAndFilter/CategoryFilter/CategoryFilter.types';

const MainCategoryFilterItem: React.FC<CategoryWithSubcategoryFilterItemProps> = (props) => {
    const { item, index, onCategoriesChange } = props;

    const onClick = (event: React.MouseEvent<HTMLInputElement>) => {
        // prevent expand the accordion when click the checkbox
        event.stopPropagation();
    };

    return (
        <Box
            data-element-name="activities-categories-filter"
            data-testid="activities-categories-filter"
            data-element-index={index + 1}
            flexDirection="row"
            display="flex"
            width="100%"
            justifyContent="space-between"
            alignItems="center"
            as="button"
            aria-label={item.label}
            p="0"
        >
            <Checkbox
                key={item.label}
                selection={item.selected ? 'selected' : item.isIndeterminate ? 'indeterminate' : 'unselected'}
                onChange={onCategoriesChange}
                onClick={onClick}
            >
                <Box display="flex" alignItems="flex-start" flexDirection="column">
                    <Typography variant="body-default" textColor="base.default" textAlign="start">
                        {item.label}
                    </Typography>
                    {item.subLabel && (
                        <Typography variant="body-s" textColor="base.subtle" pt="4" textAlign="start">
                            {item.subLabel}
                        </Typography>
                    )}
                </Box>
            </Checkbox>
            <Typography variant="body-default" textColor="base.default">
                ({item.count})
            </Typography>
        </Box>
    );
};

MainCategoryFilterItem.displayName = 'MainCategoryFilterItem';

export default MainCategoryFilterItem;
